import { computed, inject, Injectable, signal } from '@angular/core';

import { PortfolioApi } from '../api/portfolio-api';
import { UserPortfolio } from '../api/models';

@Injectable({ providedIn: 'root' })
export class PortfolioState {
  private readonly api = inject(PortfolioApi);

  readonly selectedPortfolioId = signal<string>('ALL');
  readonly portfolios = signal<UserPortfolio[]>([]);

  readonly selectedPortfolio = computed(() => {
    const id = this.selectedPortfolioId();
    if (id === 'ALL') {
      return null;
    }
    return this.portfolios().find((p) => p.id === id) ?? null;
  });

  loadPortfolios(): void {
    this.api.getPortfolios().subscribe({
      next: (list) => {
        this.portfolios.set(list);
      },
    });
  }

  selectPortfolio(id: string): void {
    this.selectedPortfolioId.set(id);
  }

  reset(): void {
    this.portfolios.set([]);
    this.selectedPortfolioId.set('ALL');
  }
}
